import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
} from "@ryde/theme";

export const BulkArchiveRelationErrorDisplayStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-archive-relation-error-display-container",
  },
)`
  .bulk-archive-relation-dialog-title {
    font-weight: 700;
    margin-block-end: 10px;
  }
  .excel-table {
    width: 100%;
    margin: 20px auto 0;
    border-collapse: collapse;
    background-color: ${rydeColors.white};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

    thead > tr {
      position: sticky;
      top: 0;
    }

    th,
    td {
      padding: 10px;
      text-align: center;
      border: 1px solid ${greyMui._300};
    }

    th {
      background-color: ${deepPurpleMui._900};
      color: ${rydeColors.white};
    }

    .id-cell {
      vertical-align: middle;
      background-color: ${greyMui._100};
      font-weight: 800;
    }
  }
  .download-btn-container {
    margin-top: 20px;
    padding: 10px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .excel-table {
      thead > tr {
        position: relative;
      }
    }
  }
`;
